import React from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";

const TableTab = ({
  tableTabs,
  activeTab,
  handleActiveTab,
  onSearch,
  selectedUser,
  setSelectedUser,
  users = [],
  handleAssign,
  showAssign = false,
}) => {
  const theme = useTheme();

  return (
    <Grid container spacing={1}>
      {tableTabs.map((tab, index) => (
        <Grid item key={index} xs={2}>
          <Box
            onClick={() => handleActiveTab(index, tab.label)}
            display="flex"
            flexDirection="column"
            alignItems="center"
            p={2}
            sx={{
              cursor: "pointer",
              borderBottom:
                activeTab === index
                  ? `3px solid ${theme.palette.primary.main}`
                  : "none",
            }}
          >
            <Typography
              fontSize={14}
              color={
                activeTab === index
                  ? theme.palette.primary.main
                  : theme.palette.text.secondary
              }
              fontWeight="bold"
            >
              {tab.count}
            </Typography>
            <Typography
              fontSize={14}
              color={
                activeTab === index
                  ? theme.palette.primary.main
                  : theme.palette.text.secondary
              }
            >
              {tab.label}
            </Typography>
          </Box>
        </Grid>
      ))}

      <Grid item xs>
        <Box display="flex" justifyContent="flex-end" pr={2} margin={2}>
          <TextField
            variant="outlined"
            placeholder="Search by name"
            size="small"
            onChange={(e) => onSearch(e.target.value)}
          />
        </Box>
      </Grid>
      {showAssign && (
        <Grid item>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            gap={1}
            pr={2}
            margin={2}
          >
            <Select
              value={selectedUser}
              onChange={(e) => setSelectedUser(e.target.value)}
              displayEmpty
              size="small"
            >
              <MenuItem value="" disabled>
                Select User
              </MenuItem>
              {users.map((user) => (
                <MenuItem key={user.id} value={user.user_name}>
                  {user.user_name}
                </MenuItem>
              ))}
            </Select>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAssign}
              disabled={!selectedUser}
            >
              Assign
            </Button>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default TableTab;
